var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"binds-bottom-bar",class:[_vm.$bindsActiveTheme, _vm.barClasses]},[_c('binds-ripple',{attrs:{"binds-disabled":_vm.bindsType === 'fixed',"binds-active":_vm.BindsBottomBar.mouseEvent}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }